export default "__VITE_ASSET__4nXZhd3J__"